import { Dropdown } from "primereact/dropdown";

import { Answer, possibleAnswers } from "./Feedback";
import FeedbackAnswerRating from "./FeedbackAnswerRating";

interface FeedbackAnswersDropdownProps {
  showClear?: boolean;
  value: number;
  onChange: (value?: number) => void;
}

const noFeedbackOption = { value: -1, label: "Fara nota" };
const allOptions = [noFeedbackOption, ...possibleAnswers];

const template = (option: Answer, size: "small" | "large") => {
  return option?.value === -1 ? (
    <>{noFeedbackOption.label}</>
  ) : (
    <FeedbackAnswerRating readOnly size={size} stars={option?.value} value={option?.value} />
  );
};

export default function FeedbackAnswersDropdown({ showClear, value, onChange }: FeedbackAnswersDropdownProps) {
  return (
    <Dropdown
      optionLabel="value"
      options={allOptions}
      value={value}
      itemTemplate={(option: Answer) => template(option, "large")}
      valueTemplate={(option: Answer) => template(option, "small")}
      showClear={showClear}
      onChange={(e) => onChange(e.value)}
    />
  );
}
